"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDateDatasetsForMeasure = exports.QueryDateDatasetsForMeasureService = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var queryService_1 = require("../store/_infra/queryService");
var effects_1 = require("redux-saga/effects");
var loadAvailableDateDatasets_1 = require("./loadAvailableDateDatasets");
var fromPairs_1 = tslib_1.__importDefault(require("lodash/fromPairs"));
var dateDatasetOrdering_1 = require("../../_staging/catalog/dateDatasetOrdering");
var catalogSelectors_1 = require("../store/catalog/catalogSelectors");
var general_1 = require("../events/general");
exports.QueryDateDatasetsForMeasureService = queryService_1.createCachedQueryService("GDC.DASH/QUERY.MEASURE.DATE.DATASETS", queryService, function (query) { return sdk_model_1.serializeObjRef(query.payload.measureRef); });
/**
 * Selector that will return date datasets for a measure. The input to the selector is the dashboard query that is used
 * to obtain and cache the data.
 *
 * This selector will return undefined if the query to obtain the data for a particular measure was not yet fired or
 * processed. Otherwise will return object containing `status` of the data retrieval; if the `status` is
 * `'success'` then the `result` prop will contain the data.
 *
 * @remarks see {@link QueryMeasureDateDatasets}
 * @internal
 */
exports.selectDateDatasetsForMeasure = exports.QueryDateDatasetsForMeasureService.cache.selectQueryResult;
//
// Query implementation
//
function queryService(ctx, query) {
    var measureRef, measures, measure, intermediateInsight, dateDatasets, dateDatasetDisplayNames;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                measureRef = query.payload.measureRef;
                return [4 /*yield*/, effects_1.select(catalogSelectors_1.selectAllCatalogMeasuresMap)];
            case 1:
                measures = _a.sent();
                measure = measures.get(measureRef);
                if (!measure) {
                    throw general_1.invalidQueryArguments(ctx, "Measure " + sdk_model_1.objRefToString(measureRef) + " does not exist.", query.correlationId);
                }
                intermediateInsight = sdk_model_1.newInsightDefinition("local:headline", function (i) {
                    return i.buckets([
                        sdk_model_1.newBucket("measures", sdk_model_1.newMeasure(measure.measure.ref, function (m) { return m.localId("measure_date_datasets_availability"); })),
                    ]);
                });
                return [4 /*yield*/, effects_1.call(loadAvailableDateDatasets_1.loadDateDatasetsForInsight, ctx, intermediateInsight)];
            case 2:
                dateDatasets = _a.sent();
                dateDatasetDisplayNames = fromPairs_1.default(dateDatasets.map(function (d) { return [d.dataSet.title, dateDatasetOrdering_1.sanitizeDateDatasetTitle(d)]; }));
                return [2 /*return*/, {
                        dateDatasets: dateDatasets,
                        dateDatasetsOrdered: dateDatasetOrdering_1.sortByRelevanceAndTitle(dateDatasets, dateDatasetDisplayNames),
                        dateDatasetDisplayNames: dateDatasetDisplayNames,
                    }];
        }
    });
}
//# sourceMappingURL=queryMeasureDateDatasets.js.map